import React, { Component } from "react";
import {LoadingOutlined} from '@ant-design/icons';

class InitialLoading extends Component {
  render() {
    return (
      <div className="vh100 w100 flex align-items-center justify-content-center">
            {/*<Icon type="loading" className="fontsize40 primary-color" />*/}
	<LoadingOutlined  className="fontsize40 primary-color"/>
      </div>
    );
  }
}

export default InitialLoading;
